import { Form, FormRoot } from '../module';
import { FormArray } from '../module/form-array';
export var isRootForm = function (form) {
    return form instanceof FormRoot;
};
export var isArrayForm = function (form) {
    return form instanceof FormArray;
};
export var isNormalForm = function (form) {
    return form instanceof Form;
};
export var isFieldForm = function (form) {
    return isNormalForm(form) || isArrayForm(form);
};
